var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createApi } from "@reduxjs/toolkit/query/react";
import { showNotification } from "slices/Notifications";
import { credentialToJSON } from "../helperFunctions/publicKeyCredentialToJSON";
function handlePerformAuthentication(args, signal) {
    return __awaiter(this, void 0, void 0, function* () {
        const publicKey = PublicKeyCredential.parseRequestOptionsFromJSON(args.webauth_options);
        const credential = yield navigator.credentials.get(Object.assign(Object.assign({ publicKey }, (signal && { signal })), { mediation: args.mediation }));
        if (credential) {
            return { data: credentialToJSON(credential) };
        }
        else {
            throw new Error("dom_error.unable_to_obtain_credential");
        }
    });
}
function handleCreateCredential(args) {
    return __awaiter(this, void 0, void 0, function* () {
        const publicKey = PublicKeyCredential.parseCreationOptionsFromJSON(args);
        const credential = yield navigator.credentials.create({ publicKey });
        if (credential) {
            return { data: credentialToJSON(credential) };
        }
        throw new Error("dom_error.unable_to_create_credential");
    });
}
const navigatorCredentialsBaseQuery = (args, api) => __awaiter(void 0, void 0, void 0, function* () {
    let errorMessage = "";
    try {
        switch (args.action) {
            case "performAuthentication":
                return yield handlePerformAuthentication(args.payload, api.signal);
            case "createCredential":
                return yield handleCreateCredential(args.payload);
            default:
                errorMessage = `Unknown action: ${args.action}`;
                break;
        }
    }
    catch (error) {
        if (error instanceof DOMException && (error.name === "AbortError" || error.name === "NotAllowedError")) {
            // AbortError: conditional auth was intentionally aborted (e.g. before starting staged auth)
            // NotAllowedError: user cancelled the dialog, or presented a credential that doesn't match
            // Both are expected user interactions — return a silent error without notification.
            return { error: { message: error.name } };
        }
        else if (error instanceof Error) {
            errorMessage = `${error.name}: ${error.message}`;
        }
        else {
            errorMessage = "Unknown error occurred.";
        }
    }
    api.dispatch(showNotification({ message: errorMessage, level: "error" }));
    return {
        error: {
            message: errorMessage,
        },
    };
});
export const navigatorCredentialsApi = createApi({
    baseQuery: navigatorCredentialsBaseQuery,
    reducerPath: "navigatorCredentialsApi",
    endpoints: (builder) => ({
        performAuthentication: builder.query({
            query: (credentialRequestOptions) => ({
                action: "performAuthentication",
                payload: credentialRequestOptions,
            }),
        }),
        createCredential: builder.query({
            query: (registerRequestOptions) => ({
                action: "createCredential",
                payload: registerRequestOptions,
            }),
        }),
    }),
});
